import src from "IMAGE";
export default { src, width: 180, height: 132, blurWidth: 0, blurHeight: 0};
